var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"pagewrap"}},[(!_vm.$route.meta.withoutMap)?_c('mapbox'):_vm._e(),_c('cabecalho'),(
        _vm.$store.state.mapLoaded &&
          _vm.$store.state.initialAnimationFinish &&
          !_vm.$route.meta.withoutMap
      )?_c('div',{staticClass:"conteudo",attrs:{"id":"conteudo-wraper"}},[_c('router-view')],1):_vm._e(),(_vm.$route.meta.withoutMap)?_c('div',{staticClass:"container"},[_c('router-view')],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }